var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markbox",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_c('div',{staticClass:"short_play",on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }